var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticStyle:{"margin-bottom":"24px"},attrs:{"shadow":"false"}},[(_vm.$route.query.productNum.toString() === '1')?_c('SummaryFinancial'):_vm._e(),(_vm.$route.query.productNum.toString() === '2')?_c('SummaryCommercial'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }